import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

  constructor(private loginService: LoginService, private router: Router) { }
  ngOnInit(): void {
    let isLogged : boolean = this.loginService.checkIsLogged();
    (!isLogged) ? this.router.navigate(['/login']) : ''; 
  }

}
